/**
 * VenueChip — tiny K / P / US badge for venue-tagging rows in unified
 * tables (Open Orders, Open Positions, MyTrades). Same dimensions as the
 * existing YES/NO side chips so columns stay aligned.
 *
 * One colour family per venue, read from `VENUE_TONE` so every badge in the
 * app (this chip, PortfolioVenueBadge, the Game Detail tab) agrees: Kalshi
 * blue, Polymarket purple, Polymarket US teal. Non-Kalshi never means
 * Polymarket by default.
 */
import { VENUE_NAME, VENUE_SHORT, VENUE_TONE, type TradingVenue } from '@/lib/venues';

export type VenueTag = TradingVenue;

interface VenueChipProps {
  venue: VenueTag;
}

export function VenueChip({ venue }: VenueChipProps) {
  return (
    <span
      className={`${VENUE_TONE[venue]} rounded px-1.5 py-0.5 text-[10px] font-bold`}
      title={VENUE_NAME[venue]}
    >
      {VENUE_SHORT[venue]}
    </span>
  );
}
